module.exports = __webpack_public_path__ + "img/part3-label2.27600e8b.png";